
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Keyboard, Command, CornerDownLeft } from 'lucide-react';

export default function KeyboardShortcutsGuide({ open, onOpenChange }) {
    const shortcuts = [
        {
            category: "General",
            items: [
                { keys: ["Esc"], description: "Close drawer / modal" },
                { keys: ["Shift", "T"], description: "Toggle Timer Widget" },
            ]
        },
        {
            category: "Task Details",
            items: [
                { keys: ["Shift", "Enter"], description: "Post comment" },
            ]
        }
    ];

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-zinc-900 border-zinc-800 max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-white">
                        <Keyboard className="w-5 h-5 text-cyan-400" />
                        <span className="font-['Manrope']">Keyboard Shortcuts</span>
                    </DialogTitle>
                    <DialogDescription className="text-zinc-400">
                        Boost your productivity with these shortcuts.
                    </DialogDescription>
                </DialogHeader>

                <div className="mt-4 space-y-6">
                    {shortcuts.map((section, idx) => (
                        <div key={idx}>
                            <h3 className="text-sm font-medium text-cyan-400 mb-3 uppercase tracking-wider text-xs">
                                {section.category}
                            </h3>
                            <div className="space-y-2">
                                {section.items.map((shortcut, i) => (
                                    <div key={i} className="flex items-center justify-between group p-2 rounded-lg hover:bg-zinc-800/50 transition-colors">
                                        <span className="text-zinc-300 text-sm">{shortcut.description}</span>
                                        <div className="flex items-center gap-1">
                                            {shortcut.keys.map((key, k) => (
                                                <kbd
                                                    key={k}
                                                    className="px-2 py-1 bg-zinc-800 border-b-2 border-zinc-700 rounded text-xs text-zinc-400 font-mono min-w-[24px] text-center"
                                                >
                                                    {key}
                                                </kbd>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
}
